export interface ILegalAndVestingResponse {
  short_vested?: string | null;
  vested?: string | null;
  legal_description?: string | null;
}

export interface ILegalAndVestingData {
  shortVested?: string | null;
  vested?: string | null;
  legalDescription?: string | null;
}

export const createDefaultLegalAndVestingData = (): ILegalAndVestingData => ({});

export const convertLegalAndVestingResponseToLegalAndVestingData = ({
  legal_description,
  short_vested,
  vested,
}: ILegalAndVestingResponse): ILegalAndVestingData => ({
  vested,
  legalDescription: legal_description,
  shortVested: short_vested,
});

export const convertLegalAndVestingDataToLegalAndVestingResponse = ({
  legalDescription,
  shortVested,
  vested,
}: ILegalAndVestingData): ILegalAndVestingResponse => ({
  vested,
  legal_description: legalDescription,
  short_vested: shortVested,
});
